import { Component, HostListener, Input, OnInit} from '@angular/core';
import { setting } from '../../../../setting';
import { infoArticle } from '../article/article.interface';
import { Router } from '@angular/router';
import { InfiniteCarousel } from 'app/shared/utils/infinite-carousel';
import { HEADER_ORIGIN_STORAGE_KEY } from 'app/shared/utils/article-header-origin';


@Component({
  selector: 'usb-destination-small',
  templateUrl: './destination-small.component.html',
  styleUrls: ['./destination-small.component.scss']
})
export class DestinationSmallComponent implements OnInit {
  @Input() getClientsSettingAppBooking: any;
  public sectionDestinationSmall: any;
  public routeUploadFile:any;
  hover:boolean = false;
  public articleSmallArr: infoArticle[] = [];
  public clientSettingGlobal: any;

  carousel = new InfiniteCarousel<infoArticle>(768, 1, 3);

  constructor(

              private router: Router
            ) {
                this.routeUploadFile =  setting.routeUploadFile;
              }

  ngOnInit() {
                this.sectionDestinationSmall  = JSON.parse(this.getClientsSettingAppBooking?.clients_setting_app_booking?.section_destination_small);
                this.clientSettingGlobal = this.getClientsSettingAppBooking?.clients_setting_global;
                this.articleSmallArr = this.sectionDestinationSmall.info;

                this.carousel.setViewportWidth(window.innerWidth);
                this.carousel.setItems(this.articleSmallArr);
             }

  @HostListener('window:resize')
  onResize(): void {
    this.carousel.setViewportWidth(window.innerWidth);
  }

  articleRedirect(index: any) {
    const typeArticle = 'small'; // Aquí puedes configurar la variable small como necesites
    const id = index; // Usar el índice o el id que se pase como parámetro
    const active = 0
    // Manda la imagen/título/descripción de la tarjeta clickeada para que el header del
    // artículo los use directo, sin tener que volver a pedirlos a la API. sessionStorage (no
    // router state) porque tiene que sobrevivir a un refresh de la página del artículo.
    const article = this.articleSmallArr[index - 1];
    if (article) {
      sessionStorage.setItem(HEADER_ORIGIN_STORAGE_KEY, JSON.stringify({
        typeArticle,
        id,
        image: this.routeUploadFile + article.image,
        title: article.title,
        description: article.description
      }));
    }
    this.router.navigate([`/article/${typeArticle}/${id}/${this.getClientsSettingAppBooking.id}/${active}`]);
  }

}
